import React from "react";
import { useLocation } from "react-router-dom";

import StudentBG from "../assets/studentBG.svg";
import StudentHeader from "../components/heading/StudentHeader";
import { getLanguage } from "../utils/getLanguage";

const StudentLayout = ({ children }) => {
  const location = useLocation();
  const lang = getLanguage();
  const isRtl = lang === "ar";

  return (
    <div className={`min-h-screen bg-[#E9F1FD] ${isRtl ? "rtl" : ""}`} dir={isRtl ? "rtl" : "ltr"}>
      <div className="absolute left-0 top-0 -z-10 h-[39vw] w-full bg-white md:z-0" />

      {/* Background Image */}
      <img src={StudentBG} alt="Student Background" className="absolute top-[23vw] w-[100vw] object-cover" />
      <StudentHeader />
      <main
        className={`relative mx-auto ${location.pathname.includes("coding-area") ? "flex-grow px-4 pb-4 pt-0 sm:px-8" : "container max-w-6xl flex-grow px-4 pb-10 pt-4 sm:px-8"}`}
      >
        {children}
      </main>
    </div>
  );
};

export default StudentLayout;
